import React, { Component } from "react";
import { Typography } from "antd";
import { putStepsDone } from "../services/backend";

const { Title } = Typography;

// http://localhost:3000/?tab=redirect&url=https://amzn.to/2D6hiG8
class Redirect extends Component {
  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    // for (var pair of this.props.qsParams.entries()) {
    //   console.log(pair[0] + ", " + pair[1]);
    // }
    try {
      const id = this.props.qsParams.get("id");
      const currentTab = this.props.qsParams.get("tab").toLowerCase();

      /*
       * UPDATE WITH DATE CLICKED
       */
      //dont await
      await putStepsDone(id, { stepType: currentTab });
    } catch (error) {
      console.log("error", error);
    } finally {
      //redirect regardless
      window.location = this.props.qsParams.get("url");
    }
  }

  render() {
    return (
      <div style={styles.flexColumnCenter}>
        <Title className="loading" level={3} style={styles.heading}>
          Redirecting
        </Title>
      </div>
    );
  }
}

const styles = {
  flexColumnCenter: {
    width: "75vw",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
  },
  heading: { fontWeight: "300" },
};

export default Redirect;
